export default __webpack_public_path__ + "static/media/premium-member.a6ac17ba.svg";